import { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useTranslation } from '../i18n'
import { apiFetch } from '../utils/api'
import SEO from '../components/SEO'
import './AuthPages.css'

function ResetPasswordPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''

  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (newPassword !== confirmPassword) {
      setError(t('resetPasswordMismatch'))
      return
    }

    if (!token) {
      setError(t('resetPasswordInvalidToken'))
      return
    }

    setLoading(true)
    try {
      await apiFetch('/auth/reset-password', {
        method: 'POST',
        body: JSON.stringify({ token, new_password: newPassword }),
      })
      setSuccess(true)
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : t('resetPasswordInvalidToken'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <SEO
        title="Reset Password"
        description="Set a new password for your Intervio account."
        path="/reset-password"
        noIndex
      />
      <div className="auth-card">
        <h1>{t('resetPasswordTitle')}</h1>
        <p className="auth-subtitle">{t('resetPasswordSubtitle')}</p>

        {success ? (
          <>
            <div className="auth-success">{t('resetPasswordSuccess')}</div>
            <p className="auth-switch" style={{ marginTop: '1.5rem' }}>
              <Link to="/login">{t('resetPasswordGoToLogin')}</Link>
            </p>
          </>
        ) : (
          <>
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="reset-password">{t('resetPasswordNewPassword')}</label>
                <input
                  id="reset-password"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder={t('authPasswordPlaceholder')}
                  required
                  minLength={8}
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label htmlFor="reset-confirm">{t('resetPasswordConfirm')}</label>
                <input
                  id="reset-confirm"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder={t('authConfirmPlaceholder')}
                  required
                  minLength={8}
                />
              </div>

              {error && <div className="auth-error">{error}</div>}

              <button
                type="submit"
                className="btn btn-primary btn-large auth-submit"
                disabled={loading}
              >
                {loading ? t('resetPasswordResetting') : t('resetPasswordButton')}
              </button>
            </form>

            <p className="auth-switch">
              <Link to="/login">{t('forgotPasswordBackToLogin')}</Link>
            </p>
          </>
        )}
      </div>
    </div>
  )
}

export default ResetPasswordPage
